(() => {
  const heading = document.querySelector(".js-promo-section__top-card-heading");
  const regex = /-\d+%/;

  const percentage = heading.textContent.match(regex)[0];
  const mySpan = document.createElement("span");
  mySpan.style.color = "#9B1E20";
  mySpan.textContent = percentage;
  heading.textContent = heading.textContent.replace(percentage, "");
  heading.append(mySpan);
})();
